import __vue_component__$1 from '../common/Popup.vue.js';
import __vue_component__ from './ColorCard.vue.js';

//
var script = {
  name: 'ColorPicker',
  components: {
    ColorCard: __vue_component__,
    Popup: __vue_component__$1
  },
  props: {
    value: {
      type: String,
      default: '#000'
    }
  },

  data() {
    return {
      colors: ['#000', '#0052CC', '#172B4D', '#FF5630', '#FFAB00', '#36B37E', '#00B8D9', '#6554C0'],
      open: false
    };
  },

  computed: {
    style() {
      return {
        'background-color': this.selected
      };
    },

    selected: {
      get() {
        return this.value;
      },

      set(color) {
        this.$emit('input', color);
      }

    }
  },
  methods: {
    onTriggerClick() {
      this.open = !this.open;
    },

    onColorSelected(color) {
      this.selected = color;
      this.open = false;
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/ColorPicker/ColorPicker.vue_rollup-plugin-vue=script.js